'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.login = twentyninetimes.login || function () {

	function init() {
		var loginForm = document.querySelectorAll('.js-site-login');

		if ( loginForm ) {
			loginForm.forEach(form => {
				form.addEventListener('submit', function(e){
					e.preventDefault();

					var input = form.querySelector('input[required]'),
						password = input.value;

					if ( !password ) return;

					document.cookie = "kommune_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
					document.cookie = "kommune_pass=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

					document.cookie = "raadgivning_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
					document.cookie = "raadgivning_pass=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

					loginAuthentication(password).then(function(value) {
						var authenticated 	= value['authenticated'],
							redirect_url  	= value['redirect_url'],
							post_type		= value['post_type'],
							id 				= value['post_id'];

						if ( authenticated ) {
							var error_msg = form.querySelector('.site-search__error-msg');
							if ( error_msg ) {
								form.removeChild(error_msg);
							}

							if ( form.classList.contains('form-error') ) form.classList.remove('form-error');

							if ( post_type == 'dlpn' ) {
								// Set session cookie with the password
								// setCookie('kommune_pass', password, 0);
								// Set session cookie with the post ID
								setCookie('kommune_id', id, 0);
							} else if ( post_type == 'advice' ) {
								// Set session cookie with the password
								// setCookie('raadgivning_pass', password, 0);
								// Set session cookie with the post ID
								setCookie('raadgivning_id', id, 0);
							} else {
								// DO NOTHING
							}

							if ( redirect_url ) window.location.href = redirect_url;
						} else {
							if ( !form.classList.contains('form-error') ) {
								form.classList.add('form-error');

								var error_msg = document.createElement('SPAN');

								error_msg.setAttribute('class', 'site-search__error-msg');
								error_msg.innerHTML = 'Indtast venligst en valid kode.</br>Tip: Du kan nu også bruge Æ, Ø eller Å i koden.';

								form.appendChild(error_msg);
							}
						}
					});
				});
			});
		}
	}

	function loginAuthentication(password) {
	    // https://getbutterfly.com/how-to-replace-jquery-ajax-with-vanilla-javascript-in-wordpress/
	    const authenticatePassword = new Promise(function(resolve, reject) {
		    var xhr 	= new XMLHttpRequest(),
		    	method  = 'POST',
		        url     = load_more_params.ajaxurl,
		        action 	= 'login_authentication';

		    xhr.open(method, url, true);
		    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
		    xhr.send('action='+action+'&password='+password);

		    xhr.onload = function() {
		        if (xhr.status >= 200 && xhr.status < 400) {
		            // If successful
		            let response = JSON.parse(xhr.responseText);

		            resolve(response);

		        } else {
		            // If fail
		            console.log(xhr.response);
		        }
		    };

		    xhr.onerror = function() {
		        alert("Something went wrong... Please try again later");
		    };
		});

		return authenticatePassword;
	}

	return {
		init : init
	};

}();

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expireDays="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}